const styles = (theme) => ({
  buttonRefresh: {
    color: theme.palette.text.textContrast,
    borderColor: theme.palette.text.main,
    minWidth: "25px",
    padding: "10px",
    lineHeight: 1,
  },
  linearProgress: {
    width: "80%",
    height: 10,
    borderRadius: 5,
    backgroundColor: theme.palette.colors.gray.lighter,
  },
  paperDatagrid: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    position: "relative",
    overflow: "hidden",
    maxHeight: "200px",
  },
  loadingLinearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  chipPendente: {
    backgroundColor: theme.palette.chip.background.high,
    color: theme.palette.chip.colorText.high,
    border: "0.1px solid ",
    borderColor: theme.palette.chip.colorText.high,
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  chipResolvido: {
    backgroundColor: theme.palette.chip.background.success,
    color: theme.palette.chip.colorText.success,
    border: "0.6px solid ",
    borderColor: theme.palette.chip.colorText.success,
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  chipAndamento: {
    backgroundColor: theme.palette.chip.background.medium,
    color: theme.palette.chip.colorText.medium,
    border: "0.6px solid ",
    borderColor: theme.palette.chip.colorText.medium,
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  chipNovo: {
    backgroundColor: theme.palette.chip.background.medium,
    color: theme.palette.colors.purple.medium,
    border: "0.6px solid ",
    borderColor: theme.palette.colors.purple.medium,
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  chipDefault: {
    backgroundColor: theme.palette.chip.background.medium,
    color: theme.palette.colors.gray.darker,
    border: "0.6px solid ",
    borderColor: theme.palette.colors.gray.darker,
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  boxModal: {
    position: "absolute",
    borderRadius: "16px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: " 90%",
    maxWidth: "1000px",
    height: "700px",
    maxHeight: "90vh",
    overflowY: "auto",
    boxShadow: 24,
    bgcolor: "background.paper",
  },
  boxCicularProgress: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  boxCards: {
    display: "flex",
    gap: 1,
    width: "100%",
    flexDirection: {
      xs: "column",
      sm: "column",
      md: "row",
      lg: "row",
    },
  },
  titleCardMenor: { p: "10px", pt: "14px", fontWeight: 600 },
  boxDatagridMenor: {
    height: 235,
    overflowY: "auto",
  },
  boxTitleDatagrid: {
    padding: "10px",
    fontWeight: 600,
    mt: 1,
  },
  boxDatagrid: {
    display: "flex",
    height: "235px",
  },
  autocompleteText: {
    width: "100%",
    maxWidth: 500,
    "@media (max-width:1349px)": { width: "100%" },
    fontSize: "0.75rem", // diminui fonte geral
  },
  autocompleteFilter: {
    width: "100%",
    maxWidth: 500,
  },
  autocomplete: {
    width: "100%",

    "& .MuiAutocomplete-tag": {
      margin: "0px",
      maxWidth: "calc(100% - 0px)",
    },
    "& .MuiAutocomplete-inputRoot": {
      flexWrap: "nowrap",
      overflow: "hidden",
    },
  },
});
export default styles;
